import accountContext from "../../account/accountContext";
import { Roles } from "../models/AccountModels";
import useCompanyType from "../../shared/hooks/useCompanyType";

const useDefaultRedirect = () => {
  const { companyType, isOperator, isProvider } = useCompanyType();

  const defaultRoute = () => {
    if (!accountContext.user) {
      return "/account/sign-in";
    }

    if (accountContext.user.role === Roles.SYSTEM_ADMINISTRATOR) {
      return "/admin";
    }

    // Viewer role: QR kiosk only — no web app access
    if (accountContext.user.role === Roles.VIEWER) {
      return "/public/machines";
    }

    // MidasPilot role: the MIDAS surface is the ONLY surface (MIDAS_PILOT_ROLE_SPEC.md §5.3).
    // Must sit BEFORE the company-type logic — a pilot tenant is an ordinary operator and
    // would otherwise land on /machinery, which PilotRouteGuard then bounces (extra hop).
    // This is also what makes every AuthorizedRoute role-miss (e.g. /admin) land on /midas.
    if (accountContext.user.role === Roles.MIDAS_PILOT) {
      return "/midas";
    }

    // Legacy/unknown company type -- default to machinery
    if (companyType === 0 || isOperator) {
      return "/machinery";
    }

    // Pure provider (not operator)
    if (isProvider) {
      return "/service-board";
    }

    // Fallback
    return "/machinery";
  };

  return { defaultRoute };
}

export default useDefaultRedirect;
